import type { AsyncThunkApiConfig } from '@/store'

import { createAsyncThunk } from '@reduxjs/toolkit'
import { RejectError } from '../../typings'

/**
 * Load Order step Notifications
 *
 * @private
 */
export const loadOrderStepTrackingLink = createAsyncThunk<
  // Return type of the payload creator
  string | undefined,
  // First argument to the payload creator
  uui.domain.actions.rpc.order.LoadOrderStepTrackingLinkAction['payload'],
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('domain/order/loadOrderStepTrackingLink', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const result = await rpc('rpc/order/loadOrderStepTrackingLink', {
      category: 'rpc',
      type: 'rpc/order/loadOrderStepTrackingLink',
      payload,
    })

    if (result.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: result.errorMessage,
        error: result,
      })
    }

    return result.trackingLink
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {loadOrderStepTrackingLink}`,
      { tags: ['rpc', 'order'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Load order step notifications for ${payload.ordStepId.orderId} failed`,
      error,
    })
  }
})
